import { cx } from '@linaria/core';
import { useId } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { resets } from '@ui/css';
import { colors } from '@ui/kit/design-tokens';
import { UploadIcon, DownloadIcon, CheckmarkIcon } from '@ui/kit/icons';
import { describeArcPath } from '@utils/common';
import { withSlots, CSSRefTransition } from '@utils/react';
import { circle, icon, crossFadeDurationMs, asyncProgressCircle, checkmark, checkmarkTransitionDurationMs, label, labelContent, button, modifiers } from './atom.modal-button.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const ModalButton = withSlots(function ModalButton(props) {
  const icon$1 = props.slots.assertOne("Icon");
  const label$1 = props.slots.assertOne("Label");
  const progressId = useId();
  const isPerformingAsyncOperation = typeof props.async?.progress !== "undefined";
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsxs("button", {
      ref: props.ref,
      onClick: props.onClick,
      className: cx(button, props.async && modifiers.async.className),
      "aria-label": props["aria-label"],
      "aria-busy": props.async ? isPerformingAsyncOperation : undefined,
      "aria-describedby": props.async ? progressId : undefined,
      "data-state": isPerformingAsyncOperation ? undefined : props.state,
      disabled: props.disabled || isPerformingAsyncOperation,
      children: [/*#__PURE__*/jsxs("div", {
        className: circle,
        "data-state": isPerformingAsyncOperation ? undefined : props.state,
        children: [/*#__PURE__*/jsxs(TransitionGroup, {
          component: null,
          children: [/*#__PURE__*/jsx(CSSRefTransition, {
            timeout: crossFadeDurationMs,
            classNames: icon,
            children: ref => /*#__PURE__*/jsx("span", {
              ref: ref,
              className: icon,
              children: typeof props.async?.progress !== "undefined" ? props.async.type === "upload" ? /*#__PURE__*/jsx(UploadIcon, {
                fillPercentage: props.async.progress * 100,
                color: colors.success()
              }) : /*#__PURE__*/jsx(DownloadIcon, {
                fillPercentage: props.async.progress * 100,
                color: colors.success()
              }) : icon$1.children
            })
          }, `icon-${isPerformingAsyncOperation}`), props.async && /*#__PURE__*/jsx(CSSRefTransition, {
            timeout: crossFadeDurationMs,
            classNames: asyncProgressCircle,
            children: ref => /*#__PURE__*/jsx("svg", {
              ref: ref,
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: `0 0 70 70`,
              className: asyncProgressCircle,
              children: typeof props.async?.progress !== "undefined" && props.async.progress > 0 && /*#__PURE__*/jsx("path", {
                d: describeArcPath(70, 2, Math.min(359.99, Math.round(props.async?.progress * 360)))
              }, "progress")
            })
          }, "progress-circle")]
        }), /*#__PURE__*/jsx(CSSRefTransition, {
          in: props.state === "success" && !isPerformingAsyncOperation,
          timeout: checkmarkTransitionDurationMs,
          classNames: checkmark,
          mountOnEnter: true,
          unmountOnExit: true,
          children: ref => /*#__PURE__*/jsx("span", {
            ref: ref,
            className: checkmark,
            children: /*#__PURE__*/jsx(CheckmarkIcon, {
              height: 9
            })
          })
        })]
      }), /*#__PURE__*/jsx("div", {
        className: label,
        children: /*#__PURE__*/jsx(TransitionGroup, {
          component: null,
          children: /*#__PURE__*/jsx(CSSRefTransition, {
            timeout: crossFadeDurationMs,
            classNames: labelContent,
            children: ref => /*#__PURE__*/jsx("span", {
              ref: ref,
              className: labelContent,
              children: typeof props.async?.progress !== "undefined" ? `${Math.round(props.async.progress * 100)}%` : label$1.children
            })
          }, String(isPerformingAsyncOperation))
        })
      })]
    }), props.async && /*#__PURE__*/jsx("span", {
      className: resets.screenReaderOnlyCls,
      id: progressId,
      "aria-label": `Status for ${props.async.type}`,
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": props.async?.progress ? Math.round(props.async.progress * 100) : 0
    })]
  });
});

export { ModalButton };
//# sourceMappingURL=atom.modal-button.js.map
